package org.example.project.screens_cus_mobile

import org.example.project.service.LoginService
import org.example.project.service.ZustandManager
import org.example.project.utils.All

private const val MOBILE_BEARBEITER_USER_ID = "mobile.bearbeiterUserId"
private const val MOBILE_BEARBEITER_NAME = "mobile.bearbeiterName"
private const val MOBILE_BEARBEITER_KUERZEL = "mobile.bearbeiterKürzel"
private const val MOBILE_BEARBEITUNG_GESTARTET_UM = "mobile.bearbeitungGestartetUm"

fun mobileCurrentBearbeiterId(): String =
    mobileBearbeiterId(LoginService.getUser())

fun mobileIsOwnBearbeitung(entry: All, userId: String = mobileCurrentBearbeiterId()): Boolean =
    userId.isNotBlank() && entry.mobileBearbeiterUserId == userId

fun mobileIsSelectableAngekommen(entry: All, userId: String = mobileCurrentBearbeiterId()): Boolean =
    entry.zustand == ZustandManager.RESERVIERT &&
        entry.mobileBearbeiterUserId.let { it.isBlank() || it == userId }

fun mobileIsLkwFlowZustand(entry: All): Boolean =
    entry.zustand == ZustandManager.TOR_ZUGEWIESEN ||
        entry.zustand == ZustandManager.PIN_ABFRAGE ||
        entry.zustand == ZustandManager.IN_VERLADUNG

fun mobileIsOwnRunning(entry: All, userId: String = mobileCurrentBearbeiterId()): Boolean =
    mobileIsOwnBearbeitung(entry, userId) &&
        mobileIsLkwFlowZustand(entry)

fun mobileIsUnassignedRunning(entry: All): Boolean =
    entry.mobileBearbeiterUserId.isBlank() &&
        mobileIsLkwFlowZustand(entry)

fun mobileClaimForCurrentUser(entry: All): All {
    val user = LoginService.getUser()
    val userId = mobileBearbeiterId(user)
    if (userId.isBlank()) return entry
    if (entry.mobileBearbeiterUserId.isNotBlank()) {
        return if (entry.mobileBearbeiterUserId == userId && entry.mobileBearbeitungGestartetUm.isBlank()) {
            entry.copy(mobileBearbeitungGestartetUm = mobileClaimTime())
        } else {
            entry
        }
    }
    val name = listOf(user?.vorname.orEmpty(), user?.nachname.orEmpty())
        .filter { it.isNotBlank() }
        .joinToString(" ")
        .ifBlank { user?.personalnummer.orEmpty().ifBlank { userId } }
    val kürzel = user?.kuerzel.orEmpty().ifBlank {
        listOf(user?.vorname.orEmpty(), user?.nachname.orEmpty())
            .mapNotNull { it.trim().firstOrNull()?.uppercaseChar()?.toString() }
            .joinToString("")
            .ifBlank { user?.personalnummer.orEmpty().ifBlank { userId } }
    }
    return entry.copy(
        mobileBearbeiterUserId = userId,
        mobileBearbeiterName = name,
        mobileBearbeiterKuerzel = kürzel,
        mobileBearbeitungGestartetUm = mobileClaimTime()
    )
}

private fun mobileBearbeiterId(user: All?): String =
    user?.id.orEmpty().trim()
        .ifBlank { user?.personalnummer.orEmpty().trim() }
        .ifBlank { user?.kuerzel.orEmpty().trim() }

private fun mobileClaimTime(): String {
    val date = kotlin.js.Date()
    return "${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}"
}
